import { Box, Button, CircularProgress, Grid, IconButton, InputAdornment, Menu, MenuItem, Tooltip } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@mui/icons-material/Search';
import CustomInput from "components/CustomInput";
import { linkedAssetsStyle } from "features/IssuesTracker/LinkedAssetsSelector/style";
import { searchByFieldTypes } from "features/vehicles/consts";
import { useSearchByIdentifierQuery } from "features/vehicles/vehicleSlice";
import { IconCar } from "icons";
import { useEffect, useRef, useState } from "react";

const SearchForAsset = ({ field, value, clientAccountId, onChange, resetSearch }) => {
    const classes = linkedAssetsStyle();

    const [params, setParams] = useState(null);

    const { data: vehicles, error: vehicleError, isLoading: isLoadingVehicle } = useSearchByIdentifierQuery(params ?? {}, { skip: !params });

    const [options, setOptions] = useState([]);
    const anchorRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    let disabled = !clientAccountId || !value || (field == searchByFieldTypes.VIN ? value?.length < 6 : field == searchByFieldTypes.ASSET_ID ? value?.length < 2 : true);

    const onSearch = (event) => {
        const inputEl = document.getElementById(`search-${field}`) || anchorRef.current || event.currentTarget;
        setAnchorEl(inputEl);

        const params = {
            clientAccountId: clientAccountId
        };
        if (field == searchByFieldTypes.VIN) params.vin = value;
        if (field == searchByFieldTypes.ASSET_ID) params.assetId = value;
        setParams(params);
    }

    useEffect(() => {
        if (!params) return;
        setOptions(vehicles ?? []);
    }, [vehicles, params]);

    useEffect(() => {
        if (resetSearch) {
            setOptions([]);
            setParams(null);
            setAnchorEl(null);
        }
    }, [resetSearch]);
    
    return (
        <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center' }} ref={anchorRef}>
                <CustomInput
                    id={`search-${field}`}
                    elementType="input"
                    label={field ==searchByFieldTypes.VIN ? 'VIN' : 'Asset ID'}
                    value={value}
                    onChange={(val) => onChange(field, val)}
                    onClick={() => !!options?.length && setAnchorEl(document.getElementById(`search-${field}`) || anchorRef.current)}
                    endAdornment={(
                        <InputAdornment position="end">
                            <IconButton size="small" style={{ marginRight: 5 }} onClick={() => {onChange(field, ''); setOptions([]); setParams(null); setAnchorEl(null);}}>
                                <CloseIcon size='small'/>
                            </IconButton>
                            <Tooltip title={!clientAccountId ? "Please select a client to be able to search" :
                            disabled ? (field == searchByFieldTypes.VIN ? "Minimum 6 characters required" : "Minimum 2 characters required") : "Search for asset"}>
                                <span>
                                    <Button
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={(e) => onSearch(e)}
                                        disabled={disabled}
                                        color="primary"
                                        variant="contained"
                                        aria-controls={Boolean(anchorEl) ? 'basic-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={Boolean(anchorEl) ? 'true' : undefined}
                                    >
                                        <SearchIcon />
                                    </Button>
                                </span>
                            </Tooltip>
                        </InputAdornment>
                    )}
                />
            </div>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => {setAnchorEl(null);} }
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    MenuListProps={{ style: { maxHeight: 320, minWidth: anchorEl ? anchorEl.offsetWidth : 360 } }}
                >
                {(options.length ? options.map((v, idx) => (
                        <MenuItem key={idx} onClick={() => { onChange(field, v); setAnchorEl(null); }}>
                            <Grid container xs={12} alignItems='center' justifyContent='space-between'>
                                <Grid item>
                                    <Grid container alignItems='center'>
                                        <Grid item className={classes.itemIcon} style={{ paddingRight: 8 }}>
                                            <IconCar width={20} height={20} />
                                        </Grid>
                                        <Grid item>
                                            <Grid container direction='column'>
                                                {v?.descriptor ? <Grid item ><label className={classes.itemLabel}> VIN: </label>{v?.descriptor}</Grid> : null}
                                                {v?.assetId ? <Grid item ><label className={classes.itemLabel}> Asset ID: </label>{v?.assetId}</Grid> : null}
                                                {v?.licensePlate ? <Grid item ><label className={classes.itemLabel}> License Plate: </label>{v?.licensePlate}</Grid> : null}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </MenuItem>
                    )) : (
                        <MenuItem>
                            <Box width="100%">
                                {isLoadingVehicle ? <CircularProgress size={24}/> : "No results"}
                            </Box>
                        </MenuItem>
                    )
                )}
            </Menu>
        </div>
    );
}

export default SearchForAsset;